<app-header-panel field="{{currentPage.item}}_header"></app-header-panel>

<div *ngIf="isArray(currentAttributes)">
  <div *ngFor="let item of currentAttributes; let itemIndex = index;"
       class="panel panel-default">
    <!-- slight hack to set meta on individual items for error handling, also sets up the display_fields for each item -->
    {{ setMeta(item, currentMeta.child) }}
    <div class="panel-heading">
      <b>{{ currentMeta.label }} #{{ itemIndex + 1 }}</b>
      <help-button field="{{ currentPage.item }}_general_help"></help-button>
      <span class="pull-right" style="cursor:pointer;" *ngIf="!currentPage.required && !item._meta.required"
            (click)="remove(item, itemIndex)"><b>Remove</b>
                <i class="fa fa-fw fa-times-circle fa-lg"></i>
            </span>
    </div>
    <div class="panel-body">
      <div *ngFor="let key of item._meta.display_fields">
        <app-dynamic-input [item]="item"
                           [itemIndex]="itemIndex"
                           [meta]="item._meta"
                           [key]="key"
                           (change)="currentPage.onItemChange ? currentPage.onItemChange(item, currentPage) : null">
          <help-button *ngIf="key !== 'shape'" field="{{ currentPage.item }}_{{key}}"></help-button>
          <ng-container map-help *ngIf="key === 'shape'">
            <help-button field="map_help"
                         [showText]="true"></help-button>
          </ng-container>
          <ng-container location-help *ngIf="key === 'shape'">
            <help-button field="shape"></help-button>
          </ng-container>
        </app-dynamic-input>
       </div>
      <div class="col-md-4" style="padding-top:15px;"><b>*</b> indicates field is required</div>

    </div>
  </div>
</div>


<button *ngIf="isArray(currentAttributes)"
        (click)="addObject(currentAttributes)" class="btn btn-default">Add
  {{ currentMeta.label }}
</button>

<div class="panel panel-default" *ngIf="!isArray(currentAttributes)">
  <div class="panel-heading">
    <b>{{ currentMeta.label }}</b>
    <help-button field="{{ currentPage.item }}_general_help"></help-button>

  </div>
  <div class="panel-body">
    <div *ngFor="let key of currentPage.display_fields">
      <app-dynamic-input [item]="currentAttributes"
                         [meta]="currentMeta"
                         [key]="key">
        <help-button field="{{ currentPage.item }}_{{key}}"></help-button>
        <ng-container map-help *ngIf="key === 'shape'">
          <help-button field="map_help"
                       [showText]="true"></help-button>
        </ng-container>
        <ng-container location-help *ngIf="key === 'shape'">
          <help-button field="shape"></help-button>
        </ng-container>
      </app-dynamic-input>
    </div>
    <div class="col-md-4" style="padding-top:15px;"><b>*</b> indicates field is required</div>
  </div>
</div>

<div style="float: right">
  <a *ngIf="previousPage" [routerLink]="['/','application', route.parent.snapshot.params.type, previousPage.item]">
    <button style="margin-right: 15px;" class="btn btn-default">
      Back
    </button>
  </a>
  <!--<button class="btn btn-default" *ngIf="fileUploadService.uploading"><i class="fa fa-pulse fa-spinner"></i></button>-->

  <button *ngIf="currentPage && !fileUploadService.uploading" class="btn btn-default" (click)="validate($event)">
    Next
  </button>
</div>
